import { useWatch } from 'react-hook-form';
import { FormField } from '../../common/form';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from '../translations/CalendarView.translations.json';
import { Flex } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { FormInputNumber } from '../../common/form';
import { FormTimePicker } from '../../common/form/input/FormTimePicker';

const { addTranslations, useTranslation } = i18nNsFactory(
  'execution-calendar-view'
);
addTranslations(translations);

export function SampleLoadingFields() {
  const loadSample: boolean = useWatch({ name: 'execution.loadSample' });
  const { t } = useTranslation();
  if (!loadSample) {
    return null;
  }

  return (
    <>
      <Flex>
        <FormField
          name="execution.sampleLoadingDays"
          label={t('column.sampleLoadingDays.label')}
          required
        >
          <Flex>
            <LoadingDays name="execution.sampleLoadingDays" min={0} />
            {t('column.sampleLoadingDays.suffix')}
          </Flex>
        </FormField>
      </Flex>
      <FormField
        name="execution.sampleLoadingTime"
        label={t('column.sampleLoadingTime.label')}
        required
      >
        <FormTimePicker name="execution.sampleLoadingTime" timeFormat="HH:mm" />
      </FormField>
    </>
  );
}

const LoadingDays = styled(FormInputNumber)`
  width: 100px;
  margin-right: 8px;
  max-height: 32px;
  max-width: 120px;
`;
